module.exports = __webpack_public_path__ + "static/media/education2.8cab17b8.png";